import { EntTerritorialsUnits } from "./handBooks/territorialsUnits"
import { EntDirectoryInfoName } from "./directoryInfoName";
import { TransportItem } from "./transportItem";


export class EntMts {
  id: number | null = null
  nameRu: string | null = null
  nameKy: string | null = null
  managerFullName: string | null = null
  email: string | null = null
  phone: string | null = null
  longitude: number | undefined = undefined;
  latitude: number | undefined = undefined;
  territorialUnitId: number | null = null
  territorialUnit: EntTerritorialsUnits | null = null
  ownershipFormId: number | null = null
  ownershipForm: EntDirectoryInfoName | null = null
  transports: TransportItem[] | null = null

  territorialUnitArea:EntTerritorialsUnits | null = null;
  territorialUnitRegion:EntTerritorialsUnits | null = null;

  regionId: number | null = null
  areaId: number | null = null
}